"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeLink = exports.linkList = exports.getLinkByCode = exports.editLink = exports.addLink = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
/**
 * 描述 获取友情链接列表
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var linkList = exports.linkList = function linkList(data) {
  return _api.default.request({
    url: '/link/linkList',
    method: 'post',
    data: data
  });
};
/** 
 * 描述 新增链接
 * @author kkdy
 * @date 2021-11-25
 * @param {any} data
 * @returns {any}
 */
var addLink = exports.addLink = function addLink(data) {
  return _api.default.request({
    url: '/link/saveLink',
    method: 'post',
    data: data
  });
};
/**
 * 描述 编辑友情链接
 * @author kkdy
 * @date 2021-11-25
 * @param {any} data
 * @returns {any}
 */
var editLink = exports.editLink = function editLink(data) {
  return _api.default.request({
    url: '/link/editLink',
    method: 'post',
    data: data
  });
};
/**
 * 描述 删除友情链接
 * @author kkdy
 * @date 2021-11-25
 * @param {any} data
 * @returns {any}
 */
var removeLink = exports.removeLink = function removeLink(data) {
  return _api.default.request({
    url: '/link/removeLink',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取课程链接通过省份code
 * @author kkdy
 * @date 2021-12-02
 * @param {any} data
 * @returns {any}
 */
var getLinkByCode = exports.getLinkByCode = function getLinkByCode(data) {
  return _api.default.request({
    url: '/web/getLinkByLink',
    method: 'post',
    data: data
  });
};